import React from "react";

interface SidebarButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const SidebarButton = ({ isOpen, onClick }: SidebarButtonProps) => (
  <button
    className="hero__sidebar-button"
    aria-label="Community Navigation"
    aria-expanded={isOpen}
    aria-controls="community-sidebar-panel"
    type="button"
    onClick={onClick}
  >
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color="#6b6c72"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="m14.008 8-10-.014a1 1 0 0 1 0-2l10 .014a1 1 0 0 1 0 2ZM14 13l-10-.01a1 1 0 0 1 0-2L14 11a1 1 0 1 1 0 2ZM13.992 18l-10-.014a1 1 0 1 1 0-2l10 .014a1 1 0 0 1 0 2ZM20.71 11.305 18.719 9.3a1 1 0 0 0-1.71.7l-.018 4a1 1 0 0 0 1.7.714l2.009-1.995a1 1 0 0 0 .006-1.414h.004Z"
        fill="currentColor"
      />
    </svg>
  </button>
);

export default SidebarButton;
